import { Breadcrumbs, CrumbClickFunc } from "@amzn/stencil-react-components/breadcrumbs";
import { Col } from "@amzn/stencil-react-components/layout";
import { TabBar, TabPanel, TabSwitcher, useTabs } from "@amzn/stencil-react-components/tabs";
import { H1, Text } from "@amzn/stencil-react-components/text";
import { PageMainContainer } from "@amzn/it-shop-shared-components";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { IT_SHOP_URL } from "@/config";
import { useDocumentTitle } from "@/common/hooks/use-document-title";
import { useUrlTab } from "@/common/hooks/use-url-tab.hook";
import { AssignedHardwareTab } from "@/pages/MyHardware/components/AssignedHardwareTab/assigned-hardware-tab";
import { MY_HARDWARE_TABS } from "@/pages/MyHardware/my-hardware.constants";
import { MyHardwareDevTools } from "@/services/my-hardware/my-hardware-service.factory";

const MyHardwarePage: FC = () => {
  const history = useHistory();
  const pageHeading = getString("myHardware.pageHeading");

  const tabs = [
    { value: MY_HARDWARE_TABS.myAssets, label: getString("myHardware.myAssetsTab") },
    { value: MY_HARDWARE_TABS.myTeam, label: getString("myHardware.myTeamTab") },
  ];
  const { activeTab, onTabSelect } = useUrlTab(MY_HARDWARE_TABS.myAssets);
  const selectedTab = tabs.some((tab) => tab.value === activeTab) ? activeTab : MY_HARDWARE_TABS.myAssets;
  const { tabBarProps, tabSwitcherProps } = useTabs({ tabs, defaultTab: selectedTab, onTabSelect });

  useDocumentTitle(pageHeading);

  const onCrumbClick: CrumbClickFunc = (event, crumb) => {
    event.preventDefault();
    if (!crumb.url) return;
    if (crumb.url.startsWith("http")) {
      window.location.href = crumb.url;
    } else {
      history.push(crumb.url);
    }
  };

  return (
    <PageMainContainer paddingTop="S300">
      <Col gridGap="S300" width="100%">
        <Breadcrumbs
          crumbs={[
            { title: getString("myHardware.crumbs.itShop"), url: IT_SHOP_URL },
            { title: pageHeading },
          ]}
          onCrumbClick={onCrumbClick}
        />
        <H1>{pageHeading}</H1>
        <MyHardwareDevTools />

        <Col gridGap="S400" width="100%">
          <TabBar {...tabBarProps} selectedTab={selectedTab} />
          <TabSwitcher {...tabSwitcherProps} selectedTab={selectedTab} shouldUnmountHiddenPanels>
            <TabPanel value={MY_HARDWARE_TABS.myAssets}>
              <AssignedHardwareTab />
            </TabPanel>
            <TabPanel value={MY_HARDWARE_TABS.myTeam}>
              <Text fontSize="T200" color="neutral70">
                {getString("myHardware.teamTabUnavailable")}
              </Text>
            </TabPanel>
          </TabSwitcher>
        </Col>
      </Col>
    </PageMainContainer>
  );
};

export default MyHardwarePage;
